import { Outlet, useOutletContext } from 'react-router-dom'

import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import ApprovalGroupEmployeesTable from 'modules/approvals/components/Employees/ApprovalGroupEmployeesTable'
import contractVersions from 'modules/contracts/store/collections/contractVersions'

const EmployeesPage = () => {
  const { group } = useOutletContext<{ group: ApprovalsGroupFragment }>()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <ApprovalGroupEmployeesTable approvalGroup={group} contractVersions={contractVersions} />
      <Outlet context={{ group }} />
    </>
  )
}

export default EmployeesPage
